import React, { createContext, useState, useContext, ReactNode, useCallback } from 'react';
import { Backdrop } from '@mui/material';
import PlaneLoader from './components/PlaneLoader';

interface LoaderContextType {
  showLoader: (message?: string) => void;
  hideLoader: () => void;
  isLoading: boolean;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }
  return context;
};

interface LoaderProviderProps {
  children: ReactNode;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const [message, setMessage] = useState<string>('');

  const showLoader = useCallback((msg: string = '') => {
    setMessage(msg);
    setOpen(true);
  }, []);

  const hideLoader = useCallback(() => {
    setOpen(false);
    setMessage('');
  }, []);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader, isLoading: isOpen }}>
      {children}
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          flexDirection: 'column',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(8px)',
        }}
        open={isOpen}
      >
        <PlaneLoader message={message} light />
      </Backdrop>
    </LoaderContext.Provider>
  );
};
